// Variante 2: Lichtkegel folgt der Maus in der Karte; der Roboter (roboter.js) lädt erst, wenn die Karte in die Nähe kommt.
(() => {
  const bewegung = () => document.documentElement.classList.contains('motion');

  const init = (root) => root.querySelectorAll('[data-buehne3d]').forEach((karte) => {
    if (karte.__init) return;
    karte.__init = true;

    const licht = karte.querySelector('[data-licht]');
    if (licht && matchMedia('(hover: hover) and (pointer: fine)').matches) {
      const ziel = { x: 0, y: 0 };
      const jetzt = { x: 0, y: 0 };
      let laeuft = false;
      const schritt = () => {
        jetzt.x += (ziel.x - jetzt.x) * 0.15;
        jetzt.y += (ziel.y - jetzt.y) * 0.15;
        licht.style.setProperty('--x', `${jetzt.x.toFixed(1)}px`);
        licht.style.setProperty('--y', `${jetzt.y.toFixed(1)}px`);
        if (karte.classList.contains('licht-an')) requestAnimationFrame(schritt);
        else laeuft = false;
      };
      karte.addEventListener('pointermove', (e) => {
        const r = karte.getBoundingClientRect();
        ziel.x = e.clientX - r.left;
        ziel.y = e.clientY - r.top;
        if (!karte.classList.contains('licht-an')) { jetzt.x = ziel.x; jetzt.y = ziel.y; karte.classList.add('licht-an'); }
        if (!laeuft) { laeuft = true; requestAnimationFrame(schritt); }
      });
      karte.addEventListener('pointerleave', () => karte.classList.remove('licht-an'));
    }

    const leinwand = karte.querySelector('canvas[data-szene]');
    if (!leinwand || !bewegung()) return;
    // import() löst relativ zu diesem Skript auf, die Adresse gilt aber relativ zur Seite
    const quelle = new URL(leinwand.dataset.szene, document.baseURI).href;
    // Programm laden, sobald die Karte etwa zwei Bildschirme entfernt ist, Roboter kurz vorher aufbauen
    let programm = null;
    const vorladen = new IntersectionObserver(([e]) => {
      if (!e.isIntersecting) return;
      vorladen.disconnect();
      programm = programm || import(quelle);
    }, { rootMargin: '1600px 0px' });
    vorladen.observe(leinwand);
    let robo = null;
    let sichtbar = false;
    // nur zeichnen, solange er zu sehen ist
    const schalte = () => robo && (sichtbar ? robo.play() : robo.stop());
    new IntersectionObserver(([e]) => {
      sichtbar = e.isIntersecting;
      schalte();
    }).observe(leinwand);
    new IntersectionObserver(async ([e], beobachter) => {
      if (!e.isIntersecting) return;
      beobachter.disconnect();
      try {
        const { starte } = await (programm = programm || import(quelle));
        robo = starte(leinwand);
        karte.classList.add('geladen');
        schalte();
      } catch (fehler) {
        karte.classList.add('ohne3d');
        console.warn('3D-Roboter nicht geladen', fehler);
      }
    }, { rootMargin: '400px 0px' }).observe(leinwand);
  });

  document.addEventListener('shopify:section:load', (e) => init(e.target));
  init(document);
})();
